import * as React from 'react';
import { Tag, ITagProps } from '@revfluence/fresh';

import styles from './TagItem.module.scss';

export const TagItem: React.FC<ITagProps> = (props) => (
  <Tag {...props} className={styles.tag} />
  );
